import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../../shared/services/http-request/http-request.service';
import { Observable, of } from 'rxjs';
import { FaqItem } from '../../models/faq-item';
import { map } from 'rxjs/operators';
import { ApiRoutingUrl } from '../../../shared/Constants/api-routing-url';
import { IEbookFaqService } from './ebook-faq.service.interface';

@Injectable()
export class EbookFaqService implements IEbookFaqService {
  constructor(public http: HttpRequestService) { }

  public getTutorialURL(): Observable<string> {
    return this.http.get(ApiRoutingUrl.clientSettingsUrl).pipe(
      map(res => {
        let url = res.VideoTutorialURL;
        if (url.indexOf("watch?v=") != -1) {
          url = url.replace("watch?v=", "embed/");
        }
        return url;
      })
    );
  }

  public getFAQs(): Observable<Array<FaqItem>> {
    return this.http.getOfType<Array<FaqItem>>(ApiRoutingUrl.questionAnswers);
  }
}
